import React from "react";
import "./Settings.scss";

import { withAuthorization } from "components/Session";
import { withFirebase } from "components/Firebase";
import { compose } from "recompose";

import SectionTitle from "components/SectionTitle";
import FormSection from "components/FormSection";
import Input from "components/Input";
import Textarea from "components/Textarea";
import Button from "components/Button";
import Select from "components/Select";
import MultiSelect from "components/MultiSelect";

import Modal from "components/Modal";

import { AuthUserContext } from "components/Session";

import WorkHistoryItem from "components/WorkHistoryItem";
import LinkItem from "components/LinkItem";

import * as ROUTES from "constants/routes";
import * as OPTIONS from "constants/options";

const INITIAL_MODAL_STATES = {
  workHistory: {
    active: false,
    data: {
      position: "",
      organization: "",
      location: ""
    }
  },
  links: {
    active: false,
    data: {
      title: "",
      url: "",
      type: ""
    }
  }
};

const createDeepCopy = obj => {
  return JSON.parse(JSON.stringify(obj));
};

const INITIAL_STATE = {
  loaded: false,
  userId: "",
  sensitive: {
    email: "",
    password: "",
    emailDirty: false,
    passwordDirty: false
  },
  user: {
    userName: "",
    firstName: "",
    lastName: "",
    location: "",
    description: "",
    skills: [],
    workHistory: [],
    links: []
  },
  status: {
    userNameError: false,
    dirty: false,
    saved: false
  },
  modals: {
    ...createDeepCopy(INITIAL_MODAL_STATES)
  }
};

const EDIT_PROFILE_ACTIONS = [
  {
    label: "Cancel",
    type: "ghost",
    to: ROUTES.HOMEPAGE
  },
  {
    label: "Save Changes",
    type: "primary"
  }
];

const splitIds = id => {
  return id.split("-");
};

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }
  handleInputChange = e => {
    const { user, status } = this.state;
    const { id, value } = e.target;

    id === "userName" ? (user[id] = value.toLowerCase()) : (user[id] = value);

    status.dirty = true;

    this.setState({ user, status });
  };

  handleSensitiveInputChange = e => {
    const { sensitive, status } = this.state;
    const { id, value } = e.target;

    sensitive[id] = value;
    sensitive[`${id}Dirty`] = true;

    status.dirty = true;

    this.setState({ sensitive, status });
  };

  updateEmail = () => {
    this.props.firebase.doEmailUpdate(this.state.sensitive.email);
  };

  updatePassword = () => {
    this.props.firebase.doPasswordUpdate(this.state.sensitive.password);
  };

  handleSensitiveUpdates = () => {
    console.log("PING");
    const { sensitive } = this.state;
    if (sensitive.emailDirty) {
      console.log("email is dirty");
      this.updateEmail();
    }

    if (sensitive.passwordDirty) {
      console.log("password is dirty");
      this.updatePassword();
    }
  };

  handleUsernameBlur = e => {
    const { value } = e.target;
    const { status } = this.state;

    this.props.firebase
      .usernameAvailable(value, this.state.userId)
      .then(response => {
        status.userNameError = false;
        status.dirty = true;
        this.setState({ status });
      })
      .catch(error => {
        status.userNameError = true;
        status.dirty = false;
        this.setState({ status });
      });
  };
  handleMultiSelectChange = (name, e, limit) => {
    if (e.length > limit) return false;
    const { user, status } = this.state;

    user.skills = e;
    status.dirty = true;
    this.setState({ user, status });
  };

  handleSelectChange = (name, e) => {
    const ids = splitIds(name);
    const { form, project } = this.state;
    form[ids[0]][ids[1]] = e.value;

    project.status.dirty = true;
    this.setState({ form, project });
  };

  handleModalSelectChange = (name, e) => {
    const { modals, status } = this.state;
    const [modal, field] = splitIds(name);
    console.log(modal, field);

    modals[modal].data[field] = e;

    if (e.value !== "custom") {
      modals[modal].data.title = "";
    }

    status.dirty = true;

    this.setState({ modals, status });
  };

  handleModalInputChange = e => {
    const { modals, status } = this.state;
    const { id, value } = e.target;
    const [modal, field] = splitIds(id);

    modals[modal].data[field] = value;
    status.dirty = true;

    this.setState({ modals, status });
  };

  handleModalSubmit = e => {
    e.preventDefault();
    const name = e.target.getAttribute("data-modal");
    let { modals, user } = this.state;
    const { data } = modals[name];

    user[name].push({ ...data });
    modals = { ...createDeepCopy(INITIAL_MODAL_STATES) };

    this.setState({ user, modals });
  };

  handleAddPosition = e => {
    e.preventDefault();
  };

  handleClickDelete = e => {
    e.preventDefault();
    const index = e.target.getAttribute("data-index");

    // Get all work positions
    const { user, status } = this.state;

    user.workHistory.splice(index, 1);
    status.dirty = true;

    this.setState({ user, status });
  };

  handleLinkDelete = e => {
    e.preventDefault();
    const index = e.target.getAttribute("data-index");

    // Get all work positions
    const { user, status } = this.state;

    user.links.splice(index, 1);
    status.dirty = true;

    this.setState({ user, status });
  };

  handleWorkHistoryInputChange = e => {
    const { user } = this.state;
    const [index, type] = e.target.id.split("-");

    user.workHistory[index][type] = e.target.value;

    this.setState({ user });
  };
  handleSubmit = e => {
    e.preventDefault();
    const { userId } = this.state;

    this.handleSensitiveUpdates();

    this.props.firebase
      .user(userId)
      .update({ ...this.state.user })
      .then(() => {
        this.props.history.push(`/u/${this.state.user.userName}`);
      })
      .catch(console.error);
  };

  handleModalClose = e => {
    const name = e.target.getAttribute("data-modal");
    let { modals } = this.state;
    modals[name].active = false;

    modals = { ...createDeepCopy(INITIAL_MODAL_STATES) };

    this.setState({ modals });
  };

  handleModalOpen = e => {
    e.preventDefault();
    const name = e.target.getAttribute("data-modal");
    const { modals } = this.state;
    modals[name].active = true;

    this.setState({ modals });
  };

  getUserEmail = () => {
    this.props.firebase
      .getCurrentUser()
      .then(response => {
        const { sensitive } = this.state;
        sensitive.email = response.email;
        this.setState({ sensitive });
      })
      .catch(console.error);
  };

  componentDidMount() {
    this.getSettings();
    this.getUserEmail();
  }

  getSettings = () => {
    const userId = this.props.firebase.auth.currentUser.uid;
    this.setState({ userId });
    this.props.firebase
      .user(userId)
      .get()
      .then(response => {
        const user = response.data();
        this.setState({ user, loaded: true });
      })
      .catch(error => console.error(error));
  };
  render() {
    const {
      userName,
      firstName,
      lastName,
      location,
      description
    } = this.state.user;

    const { email, password } = this.state.sensitive;

    const { dirty, saved, userNameError } = this.state.status;

    const addPositionAction = (
      <Button
        onClick={this.handleModalOpen}
        data-modal="workHistory"
        type="primary"
      >
        + Add Work History
      </Button>
    );
    const addLinkAction = (
      <Button onClick={this.handleModalOpen} data-modal="links" type="primary">
        + Add Link
      </Button>
    );
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          <>
            <Modal
              name="workHistory"
              onClose={this.handleModalClose}
              active={this.state.modals.workHistory.active}
              title="Add Work History"
            >
              <form
                action=""
                data-modal="workHistory"
                onSubmit={this.handleModalSubmit}
              >
                <Input
                  onChange={this.handleModalInputChange}
                  value={this.state.modals.workHistory.data.position}
                  label="Position"
                  type="text"
                  name="workHistory-position"
                  required
                />
                <Input
                  onChange={this.handleModalInputChange}
                  value={this.state.modals.workHistory.data.organization}
                  label="Organization"
                  type="text"
                  name="workHistory-organization"
                  required
                />
                <Input
                  onChange={this.handleModalInputChange}
                  value={this.state.modals.workHistory.data.location}
                  label="Location"
                  type="text"
                  name="workHistory-location"
                  required
                />
                <section>
                  <Button
                    onClick={this.handleModalClose}
                    data-modal="workHistory"
                    type="secondary"
                  >
                    Cancel
                  </Button>
                  <Button data-modal="workHistory" type="primary">
                    Confirm
                  </Button>
                </section>
              </form>
            </Modal>
            <Modal
              name="links"
              onClose={this.handleModalClose}
              active={this.state.modals.links.active}
              title="Add Link"
            >
              <form
                action=""
                data-modal="links"
                onSubmit={this.handleModalSubmit}
              >
                <Select
                  name="links-type"
                  onChange={this.handleModalSelectChange}
                  value={this.state.modals.links.data.type}
                  label="Link Type"
                  options={OPTIONS.LINKS}
                />
                {this.state.modals.links.data.type.value &&
                this.state.modals.links.data.type.value === "custom" ? (
                  <Input
                    required
                    type="text"
                    onChange={this.handleModalInputChange}
                    value={this.state.modals.links.data.title}
                    label="Title"
                    name="links-title"
                    placeholder="Place a title here for your link"
                  />
                ) : null}
                <Input
                  required
                  type="url"
                  onChange={this.handleModalInputChange}
                  value={this.state.modals.links.data.url}
                  label="Link URL"
                  name="links-url"
                  placeholder="Paste the URL here"
                />
                <section>
                  <Button
                    onClick={this.handleModalClose}
                    data-modal="links"
                    type="secondary"
                  >
                    Cancel
                  </Button>
                  <Button data-modal="links" type="primary">
                    Confirm
                  </Button>
                </section>
              </form>
            </Modal>

            <div className="Settings" data-loaded={this.state.loaded}>
              <form onSubmit={this.handleSubmit} action="">
                <div style={{ margin: "auto", width: 960 }}>
                  <br />
                  <br />
                  <br />
                  <br />
                  <SectionTitle title="Edit Profile">
                    {EDIT_PROFILE_ACTIONS &&
                      EDIT_PROFILE_ACTIONS.map((action, i) => {
                        if (action.type === "primary") {
                          return (
                            <Button
                              disabled={!dirty && !saved}
                              key={i}
                              type={action.type}
                            >
                              {saved && !dirty ? "Saved" : action.label}
                            </Button>
                          );
                        }
                        return (
                          <Button
                            to={`/profile/${this.state.userId}`}
                            key={i}
                            type={action.type}
                          >
                            {action.label}
                          </Button>
                        );
                      })}
                  </SectionTitle>
                  <br />
                  <br />
                  <FormSection title="Basic Information">
                    <Input
                      onChange={this.handleInputChange}
                      onBlur={this.handleUsernameBlur}
                      autoFocus
                      required
                      name="userName"
                      label="Username"
                      value={userName}
                      type="text"
                      placeholder=""
                      lowerCase
                      error={
                        userNameError
                          ? "This username is taken, please select another"
                          : null
                      }
                    />

                    <Input
                      onChange={this.handleInputChange}
                      required
                      name="firstName"
                      label="First name"
                      value={firstName}
                      type="text"
                      placeholder="John"
                    />
                    <Input
                      onChange={this.handleInputChange}
                      required
                      name="lastName"
                      label="Last name"
                      value={lastName}
                      type="text"
                      placeholder="Smith"
                    />
                    <Input
                      onChange={this.handleInputChange}
                      required
                      name="location"
                      label="Location"
                      value={location}
                      type="text"
                      placeholder="Bellevue, WA"
                    />
                    <Textarea
                      onChange={this.handleInputChange}
                      name="description"
                      label="Biography"
                      value={description}
                      placeholder="Tell us about yourself..."
                      limit={500}
                    />
                  </FormSection>
                  <FormSection title="Email and Password">
                    <Input
                      type="email"
                      onChange={this.handleSensitiveInputChange}
                      name="email"
                      label="Email address"
                      value={email}
                      placeholder="Your email address"
                      required
                    />
                    <Input
                      type="password"
                      onChange={this.handleSensitiveInputChange}
                      value={password}
                      name="password"
                      autoComplete={false}
                      label="Password"
                      placeholder="Password"
                    />
                  </FormSection>
                  <FormSection title="Skills">
                    <MultiSelect
                      options={OPTIONS.SKILLS}
                      limit={5}
                      onChange={this.handleMultiSelectChange}
                      name="skills"
                      value={this.state.user.skills}
                      label="primary"
                    />
                  </FormSection>
                  <FormSection title="Work History" action={addPositionAction}>
                    {this.state.user.workHistory &&
                      this.state.user.workHistory.map((workHistoryItem, i) => {
                        return (
                          <WorkHistoryItem
                            handleClickDelete={this.handleClickDelete}
                            onChange={this.handleWorkHistoryInputChange}
                            key={i}
                            {...workHistoryItem}
                            index={i}
                          />
                        );
                      })}
                  </FormSection>
                  <FormSection title="Links" action={addLinkAction}>
                    {this.state.user.links &&
                      this.state.user.links.map((link, i) => {
                        return (
                          <LinkItem
                            canDelete
                            handleDelete={this.handleLinkDelete}
                            key={i}
                            index={i}
                            {...link}
                          />
                        );
                      })}
                  </FormSection>
                  <SectionTitle>
                    {EDIT_PROFILE_ACTIONS &&
                      EDIT_PROFILE_ACTIONS.map((action, i) => {
                        if (action.type === "primary") {
                          return (
                            <Button
                              disabled={!dirty && !saved}
                              key={i}
                              type={action.type}
                            >
                              {saved && !dirty ? "Saved" : action.label}
                            </Button>
                          );
                        }
                        return (
                          <Button
                            to={`/profile/${this.state.userId}`}
                            key={i}
                            type={action.type}
                          >
                            {action.label}
                          </Button>
                        );
                      })}
                  </SectionTitle>
                  <br />
                  <br />
                  <br />
                  <br />
                </div>
              </form>
            </div>
          </>
        )}
      </AuthUserContext.Consumer>
    );
  }
}

const condition = authUser => !!authUser;

export default compose(
  withFirebase,
  withAuthorization(condition)
)(Settings);
